'use client'

import { PlanComparisonCard } from './plan-comparison-card'
import { EnterprisePlanCard } from '@/components/auth/enterprise-plan-card'
import type { PublicPlan } from '@/lib/billing/types'
import type { BillingChannel } from '@/lib/billing/constants'

interface PlanComparisonGridProps {
  plans: PublicPlan[]
  variant: 'pricing' | 'register'
  channel: BillingChannel
  selectedPlanId?: string | null
  onSelect?: (planId: string) => void
  onEnterpriseSelect?: () => void
  /** Registration can present Enterprise as a compact sales CTA below the grid. */
  showEnterprise?: boolean
}

export function PlanComparisonGrid({
  plans,
  variant,
  channel,
  selectedPlanId,
  onSelect,
  onEnterpriseSelect,
  showEnterprise = true,
}: PlanComparisonGridProps) {
  // Read-only Shopify showcase: no per-card selection. `group` lets every card
  // light up together on hover (group-hover in the card) so the grid reads as one
  // set the merchant reviews, not individual selectable options.
  const isShowcase = variant === 'register' && !onSelect
  const cardCount = plans.length + (showEnterprise && onEnterpriseSelect ? 1 : 0)
  const registerDesktopLayout = variant === 'register'
    ? cardCount === 1
      ? 'max-w-xs md:grid-cols-1'
      : cardCount === 2
        ? 'max-w-2xl md:grid-cols-2'
        : cardCount === 3
          ? 'max-w-4xl md:grid-cols-2 lg:grid-cols-3'
          : 'md:grid-cols-2 lg:grid-cols-4'
    : 'md:grid-cols-2 lg:grid-cols-4'

  return (
    <div
      className={`mx-auto grid w-full grid-cols-1 gap-6 ${registerDesktopLayout} ${
        isShowcase ? 'group' : ''
      }`}
    >
      {plans.map((plan) => (
        <PlanComparisonCard
          key={plan.id}
          plan={plan}
          variant={variant}
          channel={channel}
          isSelected={plan.id === selectedPlanId}
          onSelect={onSelect}
        />
      ))}
      {variant === 'register' && showEnterprise && onEnterpriseSelect ? (
        <EnterprisePlanCard onSelect={onEnterpriseSelect} />
      ) : null}
    </div>
  )
}
